module.exports = __webpack_public_path__ + "media/images/gift-thanks-title-ramen@3x-c61408c738cf33a0120f0617b9c79ea4.png";